module.exports = __webpack_public_path__ + "static/media/ic-view-24.5562b9c9.svg";